/**
 * TanStack Query hooks for `igaming-tiered`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingTieredQueryKeys,
	type CreateIgamingTieredBody,
	type ListIgamingTieredResponse,
	type IgamingTieredRow,
} from "./api";

export function useIgamingTieredList(): UseQueryResult<ListIgamingTieredResponse, Error> {
	return useQuery({
		queryKey: igamingTieredQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingTieredCreate(): UseMutationResult<IgamingTieredRow, Error, CreateIgamingTieredBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingTieredQueryKeys.all });
		},
	});
}

export function useIgamingTieredDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingTieredQueryKeys.all });
		},
	});
}
